import styled from 'styled-components';
import device from '../../mediaQueries';

const SearchBoxIcon = styled.input`
  outline: none;
  position: absolute;
  width: 23px;
  ${device.desktop`
    top: 40%;
    transform: translateY(-50%);
    left: 12px;
    `}

  ${device.mobile`
    left: 5px;
    top: 45%;`}
`;

export default SearchBoxIcon;
